import React, { useEffect, useState } from 'react';
import { Layout, Row, Col, Typography, Space } from 'antd';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import api from '../services/api';
import { useTranslation } from 'react-i18next';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

// 只放真实存在的入口。联系方式由管理员在后台「协议设置」填写（GET /api/site），
// 未填则整栏不显示——宁可不显示，也不挂占位的假电话/邮箱。
const linkStyle = { color: '#ccc' };

const Footer = () => {
  const [site, setSite] = useState(null);
  const { t } = useTranslation('common');
  useEffect(() => {
    let alive = true;
    api.get('/site').then((r) => { if (alive) setSite(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  const hasContact = site && (site.contact_email || site.contact_phone);

  return (
    <AntFooter style={{ background: '#001529', color: 'white', padding: '48px 24px 24px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Row gutter={[32, 32]}>
          <Col xs={24} sm={12} md={8}>
            <h3 style={{ color: 'white', marginBottom: '16px' }}>iDelivery</h3>
            <p style={{ color: '#ccc', marginBottom: '16px' }}>
              {t('footer.tagline')}
            </p>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <h4 style={{ color: 'white', marginBottom: '16px' }}>{t('footer.product')}</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link href="/trips" style={linkStyle}>{t('footer.trips')}</Link>
              <Link href="/requests" style={linkStyle}>{t('footer.requests')}</Link>
              <Link href="/orders" style={linkStyle}>{t('footer.orders')}</Link>
            </div>
          </Col>

          {hasContact && (
            <Col xs={24} sm={12} md={8}>
              <h4 style={{ color: 'white', marginBottom: '16px' }}>{t('footer.contact')}</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {site.contact_email && (
                  <Space>
                    <MailOutlined />
                    <Link href={`mailto:${site.contact_email}`} style={linkStyle}>{site.contact_email}</Link>
                  </Space>
                )}
                {site.contact_phone && (
                  <Space>
                    <PhoneOutlined />
                    <Text style={{ color: '#ccc' }}>{site.contact_phone}</Text>
                  </Space>
                )}
                {site.contact_hours && (
                  <Text style={{ color: '#ccc', fontSize: '12px' }}>{site.contact_hours}</Text>
                )}
              </div>
            </Col>
          )}
        </Row>

        <div style={{ marginTop: '32px', paddingTop: '24px', borderTop: '1px solid #333', textAlign: 'center' }}>
          <Text style={{ color: '#999' }}>
            {t('footer.rights', { year: new Date().getFullYear() })} |
            <Link href="/privacy" style={{ color: '#999', marginLeft: '8px' }}>{t('footer.privacy')}</Link>
            <Link href="/terms" style={{ color: '#999', marginLeft: '8px' }}>{t('footer.terms')}</Link>
          </Text>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;
